import { createRoot } from "react-dom/client";
import App from "./App";

createRoot(document.getElementById("product-alternatives-root")!).render(<App />);
